import { z } from 'zod';
/**
 * 附件 schema：版本/item 可掛附件（規格書、承認書、PCB layout 圖等）。
 *
 * 流程：
 *   1. 前端 POST /tenants/:tid/attachments/presign  ← 取得 PUT URL
 *   2. 前端用該 URL PUT 檔到 S3
 *   3. 業務操作（如 PATCH item）把 attachment_id 加到 BomItem.attachment_keys[]
 *   4. 下載：GET /tenants/:tid/attachments/:aid  ← 302 redirect 到 presigned GET URL
 */
/** 允許上傳的 MIME 類別（白名單，防止 .exe 等危險檔上傳） */
export const AllowedMimeEnum = z.enum([
    'application/pdf',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'image/png',
    'image/jpeg',
    'image/gif',
    'image/webp',
    'application/zip',
    'text/plain',
    'text/csv',
]);
/** POST /tenants/:tid/attachments/presign 請求 */
export const PresignUploadSchema = z.object({
    filename: z.string().min(1).max(255),
    content_type: AllowedMimeEnum,
    /** 用途分類（version_attachment / item_attachment / approval_doc / general） */
    purpose: z
        .enum(['version_attachment', 'item_attachment', 'approval_doc', 'general'])
        .default('general'),
    /** 預期檔案大小，給 S3 ContentLength 校驗（上限 50MB） */
    size_bytes: z
        .number()
        .int()
        .min(1)
        .max(50 * 1024 * 1024),
});
export const PresignUploadResponseSchema = z.object({
    attachment_id: z.string().uuid(),
    upload_url: z.string().url(),
    s3_key: z.string(),
    expires_in_seconds: z.number().int(),
});
//# sourceMappingURL=attachment.js.map